import React from "react";
import {
    Checkbox,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";

import LinhaIntegracaoBma from "./LinhaIntegracaoBma";
import RodapeTabela from "./RodapeTabela";
import { BORDA_SUAVE, BORDA_SUAVE_CLARA, NAVY, SUPERFICIE, somarTotalFaturamento } from "./utils";

const TabelaIntegracaoBma = ({
    itens = [],
    selecao,
    tiposServico = [],
    somenteLeitura = false,
    onSalvarCodigoCliente,
    onSalvarCampoServico,
    onConfirmar,
    onIntegrar,
    onDesconfirmar,
    onIgnorar,
    onReconsiderar,
    onGerar,
    onVerHistorico
}) => {
    const {
        selecionados,
        expandidos,
        todosSelecionados,
        algumSelecionado,
        selecionarTodos,
        selecionar,
        expandir
    } = selecao;

    const totalGeral = somarTotalFaturamento(itens);

    return (
        <TableContainer
            component={Paper}
            elevation={0}
            sx={{ overflowX: "auto", boxShadow: "none" }}
        >
            <Table
                size="small"
                sx={{
                    "& .MuiTableBody-root .MuiTableRow-root:hover": {
                        backgroundColor: "rgba(19, 35, 80, 0.025)"
                    },
                    "& .MuiTableCell-root": {
                        borderBottom: `1px solid ${BORDA_SUAVE_CLARA}`
                    }
                }}
            >
                <TableHead>
                    <TableRow sx={{ backgroundColor: SUPERFICIE, "& th": { fontWeight: 700, color: NAVY, borderBottom: `1px solid ${BORDA_SUAVE}` } }}>
                        <TableCell width={40} />
                        <TableCell width={50} padding="checkbox">
                            <Checkbox
                                checked={todosSelecionados}
                                indeterminate={algumSelecionado}
                                onChange={selecionarTodos}
                                disabled={somenteLeitura}
                                inputProps={{ "aria-label": "Selecionar todos" }}
                            />
                        </TableCell>
                        <TableCell>Cliente</TableCell>
                        <TableCell>Cód. SISDM</TableCell>
                        <TableCell align="center">Dia Fat.</TableCell>
                        <TableCell align="center">Dia Venc.</TableCell>
                        <TableCell align="right">Valor Total</TableCell>
                        <TableCell align="center">Status</TableCell>
                        <TableCell align="center">Ações</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {itens.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                                <Typography variant="body2" color="text.secondary">
                                    Nenhum faturamento encontrado para o filtro atual.
                                </Typography>
                            </TableCell>
                        </TableRow>
                    )}

                    {itens.map((item) => (
                        <LinhaIntegracaoBma
                            key={item.id}
                            item={item}
                            tiposServico={tiposServico}
                            expandida={Boolean(expandidos[item.id])}
                            selecionada={selecionados.includes(item.id)}
                            somenteLeitura={somenteLeitura}
                            onExpandir={() => expandir(item.id)}
                            onSelecionar={() => selecionar(item.id)}
                            onSalvarCodigoCliente={onSalvarCodigoCliente}
                            onSalvarCampoServico={onSalvarCampoServico}
                            onConfirmar={onConfirmar}
                            onIntegrar={onIntegrar}
                            onDesconfirmar={onDesconfirmar}
                            onIgnorar={onIgnorar}
                            onReconsiderar={onReconsiderar}
                            onGerar={onGerar}
                            onVerHistorico={onVerHistorico}
                        />
                    ))}
                </TableBody>
            </Table>

            <RodapeTabela
                registros={itens.length}
                total={totalGeral}
                selecionados={selecionados.length}
            />
        </TableContainer>
    );
};

export default React.memo(TabelaIntegracaoBma);
